
/*========================================
        Imports!!!
=========================================*/

/*--BrowserRouter--*/
import React from 'react';
import { Link, useNavigate } from 'react-router';
import { useState } from 'react';

/*--css--*/
import '../assets/css/wine.css';
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


/*--cows footer--*/

import mu1 from '../assets/cowsss/lower/3.webp';
import mu2 from '../assets/cowsss/lower/5.webp';
import mu3 from '../assets/cowsss/lower/6.webp';
import mu4 from '../assets/cowsss/lower/7.webp';
import mu5 from '../assets/cowsss/lower/4.webp';
import mu6 from '../assets/cowsss/lower/1.webp';
import social2 from '../assets/icons/phone.webp';
import social3 from '../assets/icons/insta.webp';

/*--logo--*/
import logo from '../assets/img/logo.webp';

/*--wine images--*/

import wine1 from '../assets/wine/lower/winnnica.webp';
import wine2 from '../assets/wine/lower/vinsanta3.webp';
import wine3 from '../assets/wine/lower/schody.webp';
import wine4 from '../assets/wine/lower/darkGrapes3.webp';
import wine5 from '../assets/wine/lower/LightGrapesOnTheTrees2.webp';
import wine6 from '../assets/wine/lower/zbiorniki.webp';
import wine7 from '../assets/wine/lower/lezakowanie2.webp';
import wine8 from '../assets/wine/lower/vinsanta5.webp';
import wine9 from '../assets/wine/lower/czerwonekrzaki.webp';
import wine10 from '../assets/wine/lower/lightGrapes.webp';
import wine11 from '../assets/wine/lower/beczki2.webp';
import wine12 from '../assets/wine/lower/schody2.webp';
import wine13 from '../assets/wine/lower/vinsanta1.webp';
import wine14 from '../assets/wine/lower/vinsanta2.webp';
import wine15 from '../assets/wine/lower/vinsanta4.webp';


import degustacja from '../assets/wine/lower/degustacje.webp';

/*--higher--*/

/*--cows footer--*/

import mu1h from '../assets/cowsss/higher/3.webp';
import mu2h from '../assets/cowsss/higher/5.webp';
import mu3h from '../assets/cowsss/higher/6.webp';
import mu4h from '../assets/cowsss/higher/7.webp';
import mu5h from '../assets/cowsss/higher/4.webp';
import mu6h from '../assets/cowsss/higher/1.webp';

import wine7h from '../assets/wine/higher/lezakowanie2.webp';
import wine8h from '../assets/wine/higher/vinsanta5.webp';
import wine12h from '../assets/wine/higher/schody2.webp';
import wine13h from '../assets/wine/higher/vinsanta1.webp';
import wine15h from '../assets/wine/higher/vinsanta4.webp';

import degustacjah from '../assets/wine/higher/degustacje.webp';

/*========================================
        Functions!!!
=========================================*/


function Middle({Changing3}) {
    return (
        <>
          <article className='Wine'>
          <section className='WineContent'>
            {/*--Wine description--*/}
              <Row className='WineDescription'>
                <Col>
                  <h1>Dlaczego nasze wino jest wyjątkowe?</h1>
                  <div className="wine-image-container" />
                <p>
                  Nasze wino jest wyjątkowe, bo powstaje z pasji, cierpliwości i szacunku do natury.
                  Tworzymy je w małych partiach, ręcznie doglądając każdego etapu – od zbioru winogron po butelkowanie.
                  Nie przyspieszamy procesów, nie poprawiamy natury – pozwalamy winu dojrzewać we własnym tempie.
                  W każdej butelce zamykamy smak miejsca, w którym rosną nasze winorośle – zapach ziemi po deszczu, letni wiatr i słońce.
                  Wierzymy, że dobre wino opowiada historię.
                  Nasze opowiada ją szczerze, bez pośpiechu i bez kompromisów.
                </p>
                </Col>
              </Row>
            {/*--Grapes gallery--*/}
              <Row className='gallery'>
                <Col lg={6}>
                    <img onLoad={Changing3} src={wine1} alt='wine' id="wine1"/>
                    <img onLoad={Changing3} src={wine2} alt='wine' id="wine2"/>
                    <img onLoad={Changing3} src={wine3} alt='wine' id="wine3"/>
                    <img onLoad={Changing3} src={wine4} alt='wine' id="wine4"/>
                    <img onLoad={Changing3} src={wine5} alt='wine' id="wine5"/>
                    
                    <img onLoad={Changing3} src={wine6} alt='wine' id="wine6"/>
                    <img onLoad={Changing3} src={wine7} alt='wine' id="wine7"/>
                    <img onLoad={Changing3} src={wine8} alt='wine' id="wine8"/>
                </Col>
                <Col lg={6}>
                  <img onLoad={Changing3} src={wine9} alt='wine'  id="wine9"/>
                  <img onLoad={Changing3} src={wine10} alt='wine' id="wine10"/>
                  <img onLoad={Changing3} src={wine11} alt='wine' id="wine11"/>
                  <img onLoad={Changing3} src={wine12} alt='wine' id="wine12"/>
                  <img onLoad={Changing3} src={wine13} alt='wine' id="wine13"/>
                  <img onLoad={Changing3} src={wine14} alt='wine' id="wine14"/>
                  
                  <img onLoad={Changing3} src={wine15} alt='wine' id="wine15"/>
                </Col>
              </Row>
            {/*-- Słownik winiarski--*/}
              <Row className='Dictionary'>
                <Col lg={12} className='DictionaryDescr'>
                  <h2>Słownik winiarski</h2>
                  <p>
                    W świecie wina można czasem poczuć się jak na wykładzie z chemii. Dlatego stworzyliśmy ten prosty słownik, dla każdego, kto po prostu lubi dobre wino i nie chce się stresować trudnymi słowami.
                  </p>
                </Col>
                <Col lg={12} className='Definitions'>
                  <dl>
                      <dt>Szczep</dt>
                      <dd>Czyli rodzaj winorośli. Tak jak różnią się jabłonie (antoniówki, papierówki), tak samo różnią się winogrona. Od szczepu zależy smak wina – jedne są owocowe, inne bardziej korzenne. Przykłady? Cabernet Sauvignon, Chardonnay, Regent.</dd>
                  </dl>
                  <dl>
                      <dt>Taniny</dt>
                      <dd>To naturalne związki w winie, głównie czerwonym, które powodują uczucie "ściągania" na języku. Dają winu charakter i strukturę. Dzięki nim niektóre wina starzeją się pięknie, stając się z czasem łagodniejsze i bardziej eleganckie.</dd>
                  </dl>
                  <dl>
                      <dt>Bukiet</dt>
                      <dd>Nie chodzi o kwiaty! Bukiet to zapach wina. Może pachnieć owocami, przyprawami, kawą, skórą albo świeżo skoszoną trawą. Każde wino ma swój własny zapachowy podpis.</dd>
                  </dl>
                  <dl>
                      <dt>Dekantacja</dt>
                      <dd>To przelewanie wina z butelki do specjalnego naczynia (karafki). Robi się to po to, żeby oddzielić wino od ewentualnego osadu i dać mu "pooddychać", dzięki czemu smaki i aromaty lepiej się otwierają.</dd>
                  </dl>
                  <dl>
                      <dt>Fermentacja</dt>
                      <dd>Najważniejszy proces – to wtedy sok z winogron zamienia się w wino. Dzieje się to dzięki drożdżom, które "zjadają" cukier i w zamian produkują alkohol i aromaty.</dd>
                    </dl>
                </Col>
              </Row>
            {/*--Degustation--*/}
              <section className='degustation'>
                <Row>
                  <Col lg={6} md={6} >
                    <img src={degustacja} alt='degustacja' id="degustacja"/>
                  </Col>
                  <Col lg={6} md={6} className='zaproszenie'>
                    <div>
                      <h2>Degustacje!</h2>
                      <hr/>
                      <p>Odkryj smak naszej pasji. Zapraszamy na kieliszek wina w wyjątkowej atmosferze.</p>
                    </div>
                  </Col>
                </Row>
              </section>
            </section>
          </article>
      </>
    );
}


/*========================================
        Functions!!!
=========================================*/

function LinkToContact() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Contact');
  };

  return (
    <button onClick={handleClick}>O nas</button>
  );
}

function LinkToProducts() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Products');
  };

  return (
    <button onClick={handleClick}>Produkty</button>
  );
}


/*========================================
        Header!!!
=========================================*/

function Header(){
  return (
    <>
    {/*====Header====*/}
    <header>
      <Row className='p-4'>
        {/*----Logo----*/}
        <Col xl={8} lg={7} md={6}>
          <div className='Logo'>
              <Link to="/" reloadDocument={true}>
                <Row>
                  <Col lg={1} md={2} xs={2} className='log'>
                    <img src={logo} alt='logo' />
                  </Col>
                  <Col  lg={10} md={9} xs={9} className='log textlog'>
                    Beskidzkie Stado
                  </Col>
                </Row>
              </Link>
          </div>
        </Col>
        {/*----Tabs----*/}
        <Col xl={4} lg={5} md={6} className='log'>
          <Row className='Tabs'>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#About' >
                <LinkToContact />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Products'>
                <LinkToProducts />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Contact'>
                <button>Kontakt</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
                <Link to="/blog" reloadDocument = {true}>
                  <button>Blog</button>
                </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      </header >
    </>
  );
}



/*========------------========*/
/*========------------========*/
/*------Footer------*/
/*========------------========*/
/*========------------========*/

function Footer({Changing3}) {
  return (
    <>
      <section className='footer'>
        <Row className='MiniGallery'>
          {/*-short gallery-*/}
          <Col lg={6} md={12} xs={12} className='mincol'>
            <section className='stadko'>
              {/*-logo-*/}
              <div className='FooterLogo'>
                <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                  <Row>
                    <Col lg={2} md={1} xs={2} className='logoFooter'>
                      <p>
                        <img src={logo} alt='logo' />
                      </p>
                    </Col>
                    <Col lg={10} md={11} xs={10} className='logoFooter'>
                      <h2>Beskidzkie Stado</h2>
                    </Col>
                  </Row>
                </a>
              </div>
              {/*-photos-*/}
              <div className='smallGallery'>
                <Row>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing3} src={mu6} alt="Cow" id="mu6"/>
                    </a>  
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing3} src={mu4} alt="Cow" id="mu4"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing3} src={mu3} alt="Cow" id="mu3"/>
                    </a>
                  </Col>
                </Row>
                <Row className='tooff'>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing3} src={mu2} alt="Cow" id="mu2"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing3} src={mu5} alt="Cow" id="mu5"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing3} src={mu1} alt="Cow" id="mu1"/>
                    </a>
                  </Col>
                </Row>
              </div>
            </section>
          </Col>
          {/*-Contact-*/}
          <Col lg={6} md={12} xs={12}  className='mincol'>
              <section className='contact' id='Contact'>
                <div>
                  <h2>Kontakt</h2>
                </div>
                <section className='links'>
                  {/*-phone-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='tel:+48 532 233 916'>
                        <img src={social2} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <span>+48 532 233 916</span>
                    </Col>
                  </Row>
                  {/*-instagram-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <img src={social3} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <span>Beskidzkie_stado</span>
                      </a>
                    </Col>
                  </Row>
                </section>
            </section>
          </Col>
        </Row>
        {/*-Copyright-*/}
        <Row>
          <Col lg={12} md={12} xs={12} className='copyright'>
            <div className='copya'>All rights reserved. Created by <a href="https://pixelpick.pl"> PixelPick</a></div>
          </Col>
        </Row>
      </section>
    </>
  );
}

function Wine() {

  const [loadedCount3, setLoadedCount3] = useState(null);

  const Changing3 = () => {
    setLoadedCount3(prev => {
      const newCount3 = prev + 1;
      if (newCount3 === 21) {
        setTimeout(() => {
          console.log("Iaam loading better quality photos now");
  
          const swap = (id, src) => {
            const el = document.getElementById(id);
            if (el) el.src = src;
            else console.warn(`${id} not found in DOM`);
          };
  
          swap("degustacja", degustacjah);
          swap("wine7", wine7h);
          swap("wine8", wine8h);
          swap("wine12", wine12h);
          swap("wine13", wine13h);
          swap("wine15", wine15h);
          swap("mu1", mu1h);
          swap("mu2", mu2h);
          swap("mu3", mu3h);
          swap("mu4", mu4h);
          swap("mu5", mu5h);
          swap("mu6", mu6h);
  
        }, 2000);
        console.log(loadedCount3);
      }
      return newCount3;
    });
  };

    return (
        <>
            <Header />
            <Middle Changing3={Changing3}/>
            <Footer Changing3={Changing3}/>
        </>
    );
}

export default Wine;